import { useMemo } from "react";
import * as THREE from "three";
import { Decal, useTexture } from "@react-three/drei";
import { StickerConfig } from "@/lib/sticker";
import { Euler, Vector3 } from "three";

interface StickerProps {
  stickerConfig: StickerConfig;
  position: Vector3;
  rotation: Euler;
  depth: number;
  size: Vector3; // 外部计算好的尺寸
}

const StickerWithTexture = ({
  stickerConfig,
  position,
  rotation,
  depth,
  size,
}: StickerProps) => {
  const texture = useTexture(stickerConfig.image as string);
  texture.minFilter = THREE.LinearFilter;
  texture.wrapS = THREE.ClampToEdgeWrapping;
  texture.wrapT = THREE.ClampToEdgeWrapping;

  const decalSize = useMemo(() => {
    // 使用外部计算好的尺寸，只需要更新深度
    return new THREE.Vector3(size.x, size.y, depth);
  }, [size, depth]);

  const materialProps = useMemo(() => {
    switch (stickerConfig.material) {
      case "matte":
        return { roughness: 0.8, metalness: 0.2 };
      case "translucent":
        return {
          roughness: 0.4,
          metalness: 0.1,
          transparent: true,
          opacity: 0.8,
        };
      case "glossy":
      default:
        return { roughness: 0.2, metalness: 0.4 };
    }
  }, [stickerConfig.material]);

  return (
    <Decal position={position} rotation={rotation} scale={decalSize}>
      <meshStandardMaterial
        {...materialProps}
        map={texture}
        polygonOffset
        polygonOffsetFactor={-10}
        side={THREE.FrontSide}
      />
    </Decal>
  );
};

export const Sticker = (props: StickerProps) => {
  if (!props.stickerConfig.image || !props.position || !props.rotation)
    return null;
  return <StickerWithTexture {...props} />;
};
